import React from "react";
import ThreeColSevenStory from "../../../../arrow/components/Rows/ThreeColSevenStory";
import { object } from "prop-types";
import "./styles.m.css";

export const ArrowThreeColSevenStories = ({ collection }) => {
  const config = {
    buttonText: `Read More`,
    showImagePlaceholder: true,
    showSection: false,
    showReadTime: false,
  };

  return (
    <div styleName="wrapper">
      <ThreeColSevenStory collection={collection} config={config} />
    </div>
  );
};

ArrowThreeColSevenStories.propTypes = {
  collection: object,
};

ArrowThreeColSevenStories.storyLimit = 17;
